module.exports = __webpack_public_path__ + "img/14.7a165ba8.jpg";